export default __webpack_public_path__ + "static/media/computer.62112f37.jpg";